
<template>
<section class="big-box">
  <section id="include-section" class="small-section">
    <h3> Include Data From: </h3>
    <div class="field left">
      <multiselect
        placeholder="Select Charity"
        v-model="data.charities"
        :options="$store.state.charities.withAll"
        track-by="value"
        label="label"
        :multiple="true"
        :hide-selected="true"
        :close-on-select="false"
      ></multiselect>
      <span class="error-message" v-if="errors.charity_ids">{{ errors.charity_ids[0] }}</span>
    </div>
    <div class="field left">
      <multiselect
        placeholder="Select Charity Status"
        v-model="data.statuses"
        :options="$store.state.charity.charityStatusAll"
        track-by="value"
        label="label"
        :multiple="true"
        :hide-selected="true"
        :close-on-select="false"
      ></multiselect>
      <span class="error-message" v-if="errors.statuses">{{ errors.statuses[0] }}</span>
    </div>
    <div class="field left">
      <multiselect
        placeholder="Select Charity State"
        v-model="data.states"
        :options="$store.state.charities.states"
        track-by="value"
        label="label"
        :multiple="true"
        :hide-selected="true"
        :close-on-select="false"
      ></multiselect>
      <span class="error-message" v-if="errors.states">{{ errors.states[0] }}</span>
    </div>
    <div class="field left">
      <multiselect
        placeholder="Select Charity City"
        v-model="data.cities"
        :options="$store.state.charities.cities"
        track-by="value"
        label="label"
        :multiple="true"
        :hide-selected="true"
        :close-on-select="false"
      ></multiselect>
      <span class="error-message" v-if="errors.cities">{{ errors.cities[0] }}</span>
    </div>
    <div class="field left">
      <multiselect
        placeholder="Select Charity Zip Code"
        v-model="data.zips"
        :options="$store.state.charities.zips"
        track-by="value"
        label="label"
        :multiple="true"
        :hide-selected="true"
        :close-on-select="false"
      ></multiselect>
      <span class="error-message" v-if="errors.zips">{{ errors.zips[0] }}</span>
    </div>
  </section>

  <section id="include-section" class="small-section">
    <h3> Report Type <span class="error-message" v-if="errors.saved_report_id">{{ errors.saved_report_id[0] }}</span></h3>
    <template v-for="report in $store.state.summary.charity_saved_reports">
      <div class="radio-option" v-bind:key="report.value.value">
        <input type="radio" name="report_type" :id="report.value.value" :value="report.value.value" v-model="data.saved_report_id">
        <label class="inline-label" :for="report.value" v-bind:key="report.label">{{ report.label }}</label>
        <a @click="setEditTemplate(report)">Edit Template</a>
      </div>
      <transition name="slide-fade" v-bind:key="report.value.value">
        <section id="include-section" class="small-section">
          <div v-if="editing_report.id === report.value.value" class="vehicle-data-fields">
            <h3> {{ report.label }} <span class="edit-template-close icon far fa-times" aria-hidden="true" @click="closeEditTemplate"></span></h3>
            <div class="template-fields">
              <draggable v-model="editing_report.fields">
                <div class="data-field" v-for="(field, index) in editing_report.fields" :key="index">
                  <chc-input class="left" v-model="field.field" label="Select Data Field" :autoCompleteValues="$store.state.constants.charity_report_data_fields" format="combo"></chc-input>
                  <span> <a @click="removeField(index, false)"> Delete </a> </span>
                </div>
                <p><a slot="footer" v-on:click="addField(false)">+ Add Another Field</a></p>
              </draggable>
              <div>
                <chc-checkbox class="left" v-model="editing_report.charity_include_chc_proceeds" label="Total CHC Proceeds (dates required)"></chc-checkbox>
                <chc-checkbox class="left" v-model="editing_report.charity_include_charity_proceeds" label="Total Charity Proceeds (dates required)"></chc-checkbox>
                <chc-checkbox class="left" v-model="editing_report.charity_include_vehicle_count" label="Total Vehicle Count (dates required)"></chc-checkbox>
              </div>
            </div>
            <div class="small-section">
              <input type="submit" class="btn" @click="saveTemplateChanges" value="Save Changes" :disabled="editing_report.isLoading || editing_report.showDeleteConfirmation"/>
              <a @click="toggleDeleteTemplate(true)" :disabled="editing_report.isLoading || editing_report.showDeleteConfirmation">Delete Template</a>
            </div>
            <div v-if="editing_report.hasSaveError" class="small-section">
              <span class="error-message">An error occurred, unable to save changes to existing template.</span>
            </div>
            <transition name="fade">
              <p v-if="editing_report.saved" class="success-message">Changes Saved</p>
            </transition>
            <div v-if="editing_report.showDeleteConfirmation" class="small-section">
              <span class="error-message">Are you sure you want to delete this template?</span>
            </div>
            <div v-if="editing_report.showDeleteConfirmation" class="small-section">
              <input type="submit" class="btn" @click="deleteTemplate" value="Delete Template" :disabled="editing_report.isLoading"/>
              <a @click="toggleDeleteTemplate(false)">Cancel</a>
            </div>
            <div v-if="editing_report.showDeleteConfirmation && editing_report.hasDeleteError" class="small-section">
              <span class="error-message">An error occurred, unable to delete saved template.</span>
            </div>
          </div>
        </section>
      </transition>
    </template>
    <div class="radio-option">
      <input type="radio" name="report_type" id="custom" value="custom" v-model="data.saved_report_id">
      <label class="inline-label" for="custom">Custom Fields (select fields below)</label>
    </div>
    <transition name="slide-fade">
      <section id="include-section" class="small-section">
        <div v-if="data.saved_report_id === 'custom'" class="vehicle-data-fields">
          <h3> Vehicle Data Fields </h3>
          <div class="template-fields">
            <draggable v-model="data.data_fields">
              <div class="data-field" v-for="(field, index) in data.data_fields" :key="index">
                <chc-input class="left" v-model="field.field" label="Select Data Field" :autoCompleteValues="$store.state.constants.charity_report_data_fields" format="combo"></chc-input>
                <span> <a @click="removeField(index)"> Delete </a> </span>
              </div>
              <p><a slot="footer" v-on:click="addField">+ Add Another Field</a></p>
            </draggable>
            <div>
              <chc-checkbox class="left" v-model="data.charity_include_chc_proceeds" label="Total CHC Proceeds (dates required)"></chc-checkbox>
              <chc-checkbox class="left" v-model="data.charity_include_charity_proceeds" label="Total Charity Proceeds (dates required)"></chc-checkbox>
              <chc-checkbox class="left" v-model="data.charity_include_vehicle_count" label="Total Vehicle Count (dates required)"></chc-checkbox>
            </div>
          </div>
          <div>
            <chc-checkbox class="left" v-model="data.save_as_report" label="Save selections as a report template"></chc-checkbox>
            <chc-input class="left" v-model="data.save_as_report_name" label="Template Name" :error="errors.save_as_report_name" ref="templateNameInput"></chc-input>
          </div>
        </div>
      </section>
    </transition>
  </section>

  <section class="small-section" v-if="showDateReference">
    <h3> Date To Reference <span class="error-message" v-if="errors.date_to_reference">{{ errors.date_to_reference[0] }}</span></h3>
    <div class="radio-option">
      <input type="radio" name="date_to_reference" id="created_at" value="created_at" v-model="data.date_to_reference">
      <label class="inline-label" for="created_at">Entry Date</label>
    </div>
    <div class="radio-option">
      <input type="radio" name="date_to_reference" id="actual_pickup" value="actual_pickup" v-model="data.date_to_reference">
      <label class="inline-label" for="actual_pickup">Tow Date</label>
    </div>
    <div class="radio-option">
      <input type="radio" name="date_to_reference" id="date_sold_or_disposed" value="date_sold_or_disposed" v-model="data.date_to_reference">
      <label class="inline-label" for="date_sold_or_disposed">Sold Date</label>
    </div>
    <div class="radio-option">
      <input type="radio" name="date_to_reference" id="check_date" value="check_date" v-model="data.date_to_reference">
      <label class="inline-label" for="check_date">Proceeds Paid</label>
    </div>
  </section>
  <section class="small-section" v-if="showDateReference">
    <h3>Date Range
      <span class="error-message" v-if="errors.from_date">{{ errors.from_date[0] }}</span>
      <span class="error-message" v-else-if="errors.to_date">{{ errors.to_date[0] }}</span>
      <span class="error-message" v-if="errors.lifetime">{{ errors.lifetime[0] }}</span>
    </h3>
    <div id="dateRange">
      <chc-input v-model="data.from_date" label="From Date" type="date"></chc-input>
      <chc-input v-model="data.to_date" label="To Date" type="date"></chc-input>
      <chc-checkbox v-model="data.lifetime" label="Lifetime"></chc-checkbox>
    </div>
  </section>
  <section id="include-section" class="small-section">
    <input type="submit" @click="submit" class="btn" :value="isLoading ? 'Generating...' : 'Download Excel File'" :disabled="isLoading">
  </section>
</section>
</template>

<script>
import store from '@/store'
import helpers from '@/helpers'
import Multiselect from 'vue-multiselect'
import draggable from 'vuedraggable'
import _ from 'lodash'

export default {
  name: 'CharityReports',
  components: {
    Multiselect,
    draggable
  },
  data () {
    return {
      data: {
        // Default values for fields
        date_to_reference: null,
        from_date: null,
        to_date: (new Date()).toJSON().slice(0, 10),
        lifetime: false,
        charities: [
          {
            label: 'All Charities',
            value: 'all'
          }
        ],
        statuses: [
          {
            label: 'All Charity Statuses',
            value: 'all'
          }
        ],
        states: [
          {
            label: 'All Charity States',
            value: 'all'
          }
        ],
        cities: [
          {
            label: 'All Charity Cities',
            value: 'all'
          }
        ],
        zips: [
          {
            label: 'All Charity Zips',
            value: 'all'
          }
        ],
        data_fields: [
          {
            field: 'name',
          },
        ],
        charity_include_chc_proceeds: false,
        charity_include_charity_proceeds: false,
        charity_include_vehicle_count: false,
      },
      editing_report: {
        id: null,
        fields: [],
        charity_include_chc_proceeds: false,
        charity_include_charity_proceeds: false,
        charity_include_vehicle_count: false,
        isLoading: false,
        showDeleteConfirmation: false,
        hasDeleteError: false,
        hasSaveError: false,
        saved: false,
      },
      errors: {},
      hasErrors: false,
      isLoading: false,
    }
  },
  methods: {
    setEditTemplate (report) {
      this.editing_report.id = report.value.value
      this.editing_report.fields = []
      let fields = JSON.parse(report.value.report_settings)
      for (var i = 0; i < fields.length; i++) {
        this.editing_report.fields.push({
          field: fields[i]
        })
        this.editing_report.charity_include_chc_proceeds = report.value.charity_include_chc_proceeds
        this.editing_report.charity_include_charity_proceeds = report.value.charity_include_charity_proceeds
        this.editing_report.charity_include_vehicle_count = report.value.charity_include_vehicle_count
      }
    },
    saveTemplateChanges () {
      this.editing_report.isLoading = true
      this.editing_report.hasSaveError = false
      store.functions.reports.updateSavedTemplate(this.editing_report.id,
        {
          fields: this.editing_report_field_ids,
          charity_include_chc_proceeds: this.editing_report.charity_include_chc_proceeds,
          charity_include_charity_proceeds: this.editing_report.charity_include_charity_proceeds,
          charity_include_vehicle_count: this.editing_report.charity_include_vehicle_count,
        },
        (err) => {
          this.editing_report.hasSaveError = true
          this.editing_report.isLoading = false
          console.log(err)
        }
      ).then(response => {
        store.dispatch('syncSummary')
        this.editing_report.isLoading = false
        this.editing_report.saved = true
        this.setEditTemplate({
          label: response.data.name,
          value: {
            value: response.data.id,
            report_settings: response.data.report_settings
          }
        })
        setTimeout(() => {
          this.editing_report.saved = false
        }, 500)
      })
    },
    toggleDeleteTemplate (show) {
      this.editing_report.showDeleteConfirmation = show
    },
    deleteTemplate () {
      this.editing_report.hasDeleteError = false
      this.editing_report.isLoading = true
      store.functions.reports.deleteSavedTemplate(this.editing_report.id, (err) => {
        console.log(err)
        this.editing_report.hasDeleteError = true
        this.editing_report.isLoading = false
      }).then(response => {
        this.closeEditTemplate()
        store.dispatch('syncSummary')
      })
    },
    closeEditTemplate () {
      this.editing_report = {
        id: null,
        fields: [],
        isLoading: false,
        showDeleteConfirmation: false,
        hasDeleteError: false,
        hasSaveError: false,
        saved: false,
      }
    },
    removeField (index, custom = true) {
      if (custom) this.data.data_fields.splice(index, 1)
      else this.editing_report.fields.splice(index, 1)
    },
    addField (custom = true) {
      if (custom) {
        this.data.data_fields.push({
          field: null,
        })
      } else {
        this.editing_report.fields.push({
          field: null,
        })
      }
    },
    submit () {
      this.isLoading = true
      let formData = Object.assign({}, this.data)
      formData.charity_ids = this.charity_ids
      formData.statuses = this.status_values
      formData.states = this.state_values
      formData.cities = this.city_values
      formData.zips = this.zip_values
      formData.data_field_ids = this.data_field_ids
      store.functions.reports.makeCharityReport(formData, (error) => {
        this.errors = error
        this.hasErrors = true
        this.isLoading = false
      }).then((response) => {
        helpers.openAsDownload(response.data, 'report_' + (new Date()).toJSON() + '.xlsx')
        if (this.data.save_as_report) {
          this.data.data_fields = [
            {
              field: 'name',
            },
          ]
          this.data.save_as_report = false
          this.$refs.templateNameInput.forceUpdateValue(null)
          store.dispatch('syncSummary')
            .then(() => {
              this.isLoading = false
            })
        }
        this.errors = {}
        this.hasErrors = false
        this.isLoading = false
      })
    },
  },
  computed: {
    data_field_ids () {
      return _.map(this.data.data_fields, 'field')
    },
    charity_ids () {
      return _.map(this.data.charities, 'value')
    },
    status_values () {
      return _.map(this.data.statuses, 'value')
    },
    state_values () {
      return _.map(this.data.states, 'value')
    },
    city_values () {
      return _.map(this.data.cities, 'value')
    },
    zip_values () {
      return _.map(this.data.zips, 'value')
    },
    editing_report_field_ids () {
      return _.map(this.editing_report.fields, 'field')
    },

    selectedReport () {
      if (this.data.saved_report_id == null || this.data.saved_report_id === 'custom') {
        return this.data.saved_report_id
      }
      return store.state.summary.charity_saved_reports.find((r) => r.value.value === this.data.saved_report_id)
    },
    showDateReference () {
      if (this.selectedReport == null) {
        return false
      }
      if (this.selectedReport === 'custom') {
        return this.data.charity_include_chc_proceeds || this.data.charity_include_charity_proceeds || this.data.charity_include_vehicle_count
      }
      return this.selectedReport.value.charity_include_chc_proceeds || this.selectedReport.value.charity_include_charity_proceeds || this.selectedReport.value.charity_include_vehicle_count
    }
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss" scoped>
@import "../../style/variables";

.edit-template-close {
  float: right;
}

.radio-option {
  margin-bottom: 1rem;
}

.vehicle-data-fields {
    border: 1px solid $lt-grey;
    border-radius: .25rem;
    background: $cream;
    padding: 1rem;
    h3 {
      margin-top: 0;
    }
    p {
      margin: 0 0 2rem 0;
    }
    .template-fields {
      display: flex;
      justify-content: space-between;
    }
    .data-field {
      .field {
        display: inline-block;
        vertical-align: middle;
      }
      span {
        margin-left: 1rem;
        margin-bottom: 2rem;
        display: inline-block;
        vertical-align: middle;
      }
    }
}

.small-section {
    margin: 2rem 0;

    input {
      margin-right: 2rem;
    }
}

.big-box {
    padding: 0 2rem;
}

.fade-enter-active, .fade-leave-active {
    opacity: 1;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    transition: opacity 3s;
    opacity: 0;
}

.slide-fade-enter-active {
    transition: all .3s ease;
}
.slide-fade-leave-active {
    transition: all .3s ease;
}
.slide-fade-enter, .slide-fade-leave-to {
    opacity: 0;
}

#dateRange {
    padding-right: 2rem;
    .field {
      width: 250px;
      margin-right: 2rem;
      display: inline-block;
      vertical-align: top;
    }
}

:not(.fixed) .field-label {
    cursor: text;
}

#caret-down {
    position: absolute;
    top: .25rem;
    right: .25rem;
}

#loader {
    position: absolute;
    top: 25%;
    right: 50%;
    color: $lt-grey;
}

.multiselect__input {
    height: 2rem;
}

.multiselect__content-wrapper {
    position: absolute;
    top: 1.7rem;
    right: 0;
    background-color: #ffffff;
    /* border-top: 2px solid $yellow; */
    border-radius: 0 0 .25rem .25rem;
    box-shadow: 0 3px 10px $dark-grey;
    padding: 0;
    list-style-type: none;
    margin: 0;
    width: 100%;
    z-index: 100;
    text-align: left;
    &:before {
        content: '';
        display: block;
        height: 3px;
        position: absolute;
        top: -5px;
        width: 100%;
        left: -1px;
    }
    li {
        margin: 0;
        padding: .50rem;
        display: block;
        &:hover {
            background: $light-blue;
        }
    }
}

.slide-enter-active, .slide-leave-active {
    transition: opacity .25s;
}
.slide-enter, .slide-leave-to /* .slide-leave-active below version 2.1.8 */ {
    opacity: 0;
}
.label-disabled {
    color: $lt-grey !important
}
</style>



// WEBPACK FOOTER //
// src/components/Reports/CharityReports.vue